/**
 * Central Quota & Abuse Prevention Configuration
 *
 * All user storage caps, item quotas, and limits are managed here.
 * Adjust these values if quotas should be increased or decreased in the future.
 */

export const QUOTA_CONFIG = {
  /** Maximum total storage in bytes per user (25 MB default) */
  USER_STORAGE_LIMIT_BYTES: 25 * 1024 * 1024,

  /** Warning threshold at 80% of total storage capacity */
  STORAGE_WARNING_THRESHOLD_PERCENT: 80,

  /** Maximum number of recipes a user can create */
  MAX_RECIPES_PER_USER: 500,

  /** Maximum number of articles a user can create */
  MAX_ARTICLES_PER_USER: 1000,

  /** Maximum number of article / recipe categories per user */
  MAX_CATEGORIES_PER_USER: 50,

  /** Maximum number of custom shopping lists or recipe books per user */
  MAX_LISTS_PER_USER: 20,

  /** Maximum number of items inside a single shopping list */
  MAX_ITEMS_PER_SHOPPING_LIST: 300,

  /** Maximum number of recurring purchases */
  MAX_RECURRING_PURCHASES_PER_USER: 200,

  /** Maximum compressed image Base64 size in bytes (200 KB) */
  MAX_IMAGE_BASE64_BYTES: 200 * 1024,

  /** Maximum allowed backup file import size (10 MB) */
  MAX_BACKUP_IMPORT_BYTES: 10 * 1024 * 1024,

  /** Maximum total items allowed in a single backup import */
  MAX_BACKUP_IMPORT_ITEMS: 3000,

  /** Multi-Tier Anti-Spam Limits for Invitations */
  INVITATIONS: {
    MAX_PER_MINUTE: 5,
    MAX_PER_HOUR: 10,
    MAX_PER_DAY: 25,
    MAX_PER_WEEK: 50,
    MAX_PENDING_PER_RESOURCE: 10
  },

  /** Trash Bin Quotas & Retention */
  TRASH: {
    MAX_ITEMS: 100,
    RETENTION_DAYS: 30
  },

  /** Feedback Quotas & Anti-Spam (Max 3 per day) */
  FEEDBACK: {
    MAX_PER_DAY: 3,
    RECIPIENT_EMAIL: 'webmaster@kochbuch-und-einkaufsliste.de'
  }
} as const

export type QuotaConfig = typeof QUOTA_CONFIG
